import React from "react";
import PartLoadBooking from "../../components/service-pages/part-load-booking/PartLoadBooking";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";
import { FaqsResponse } from "@vahak/core/dist/_services/faq.service";
import {
    getPartLoadBookingPageLayout,
    getPartLoadBookingStaticProps
} from "../../components/service-pages/constants/part-load-booking-methods";

export default function PartLoadBookingPage({ faqs }: { faqs: FaqsResponse[] }) {
    return <PartLoadBooking faqs={faqs} />;
}

PartLoadBookingPage.getLayout = getPartLoadBookingPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await getPartLoadBookingStaticProps()),
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("servicePages")))
        }
    };
}
